@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (settings().labelPosition === 'top') {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div
    uiinputcontent
    [class]="contentCssClass()"
    (click)="toggleOptionsPopup()"
  >
    <!--#region Default Icon Left -->

    @if (settings().defaultIconSlot === 'left') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Label Embedded -->

    @if (settings().labelPosition === 'embedded') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-embedded]"></ng-content>

    <!--#endregion Label Embedded -->

    <!--#region Input -->

    @if (UiValueTmpl && !isFocused() && selectedOption()) {
      <div uivalue [class]="inputCssClass()" (click)="focusin()">
        <ng-container
          *ngTemplateOutlet="
            UiValueTmpl;
            context: { $implicit: selectedOption() }
          "
        ></ng-container>
      </div>
    } @else {
      <input
        #uiValueRef
        uivalue
        type="text"
        [attr.readonly]="!settings().optionsAsyncFn ? true : undefined"
        [class]="inputCssClass()"
        [value]="formattedValue()"
        [placeholder]="settings().placeholder"
        (focusin)="focusin()"
        (input)="onSearchInputChanged(uiValueRef.value)"
      />
    }

    <!--#endregion Input -->

    <!--#region Tools -->

    <div uitoolstrip [class]="toolstripCssClass()">
      <ng-container #uiToolsDefaultRef>
        @if (
          settings().showClearButton && !isNil(value()) && !settings().disabled
        ) {
          <btn
            uihovertool
            uicleartool
            uiunpermissioned
            class="unstyled xxs"
            [settings]="{
              icon: ICONS.CLOSE_SMALL,
              iconOnly: true,
            }"
            (click)="clearValue($event); focusout()"
          >
          </btn>
        }
      </ng-container>
      <ng-template #uiToolsCodeRef></ng-template>
      <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
    </div>

    <!--#endregion Tools -->

    <!--#region Default Icon Right -->

    @if (settings().defaultIconSlot === 'right') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Right -->

    <!--#region Selection Options -->

    @if (permDir.uipermission() !== PERMISSIONS.VIEW) {
      <ul
        #uiPopupRef
        [class]="popupCssClass()"
        [UiPopup]="popupSettings()"
        (UiPopupVisibilityChanged)="popupChanged($event)"
      >
        <!-- Search -->
        @if (settings().optionsFiltering) {
          <text
            #uiSearchRef
            uipopupheader
            uiunpermissioned
            [(value)]="filterQuery"
            [settings]="{
              placeholder: 'Start typing to filter',
              placeholderPersists: true,
              tag: settings().label + ' Search',
              stateless: true,
            }"
            (click)="$event.stopPropagation()"
            (InputChanged)="onFilterInputChanged($event)"
          >
            <icon class="pinned" uitool [iconDefinition]="ICONS.FILTER"></icon>
          </text>
        }
        <!-- End Search -->
        @for (option of visibleOptions(); track i; let i = $index) {
          @let prevOptionGroup =
            i === 0
              ? undefined
              : $safeNavigationMigration(
                  visibleOptions().at(i - 1)?.[settings().optionGroup!]
                );
          @if (
            settings().optionGroup &&
            option[settings().optionGroup!] !== prevOptionGroup
          ) {
            <li uipopupgroup>{{ option[settings().optionGroup!] }}</li>
            <hr />
          }
          <li
            #uiOption
            [class]="optionCssClass()"
            [attr.uilog]="option[settings().optionLabel!]"
            [attr.uipopupoption]="uid()"
            [attr.uipopupoptionselected]="
              selectedOption()?.[settings().optionValue!] ===
              option[settings().optionValue!]
            "
            [attr.uipopupoptiondisabled]="
              option[settings().optionDisabled!] !== true ? undefined : true
            "
            (click)="select(option, $event)"
          >
            @if (UiOptionTemplateRef) {
              <ng-container
                *ngTemplateOutlet="
                  UiOptionTemplateRef;
                  context: { $implicit: option, index: $index, isFirst: $first }
                "
              ></ng-container>
            } @else {
              {{ option?.[settings().optionLabel!] }}
            }
          </li>
        }
        @if (showEmptyState()) {
          <li uipopupnonoption>There is no available info to show</li>
        }
      </ul>
    }

    <!--#endregion Selection Options -->
  </div>

  <!--#region Footer -->

  @switch (state()) {
    @case ('error') {
      <span
        uifooter
        uistate="error"
        class="cursor-help"
        [title]="errors().join('\r\n')"
        >{{
          errors().length > 1
            ? errors().at(0) +
              ' (' +
              (errors().length - 1).toString() +
              ' more)'
            : errors().at(0)
        }}</span
      >
    }
    @case ('warning') {
      <span
        uifooter
        uistate="warning"
        class="cursor-help"
        [title]="warnings().join('\r\n')"
        >{{
          warnings().length > 1
            ? warnings().at(0) +
              ' (' +
              (warnings().length - 1).toString() +
              ' more)'
            : warnings().at(0)
        }}</span
      >
    }
  }

  <!--#endregion Footer -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      uipopuptrigger
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!-- Default Icon Template-->
  <ng-template #uiDefaultIconTemplateRef>
    @if (!settings().hideDefaultIcon && !isSearching()) {
      <icon
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="defaultIcon()"
        [iconCssClass]="defaultIconCssClass()"
        (click)="toggleOptionsPopup()"
      ></icon>
    } @else if (isSearching()) {
      <icon
        class="animate-spin"
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="settings().loadingIcon"
      ></icon>
    }
  </ng-template>

  <!-- Modal Template -->
  <ng-template #uiModalsCodeRef></ng-template>

  <!--#endregion Templates -->
}
